<template v-cloak>
  <div class="view-wrap">
    <div class="view-content">
      <section id="hero" class="standard-hero bg-regular">
        <div class="section-inner">
          <div class="tagline" :class="is.mac() ? 'apple' : 'no-apple'">
            <div class="intro-text">
               <h1 class="text-left">RememBear is no longer available...</h1>
               <p class="text-left">There is no easy way to say this. Support for RememBear has ended and is no longer available to download. You can<a href="https://www.remembear.com/blog/saying-goodbye-to-remembear" target="_blank"> read more about our decision here.</a> </p>
               <p class="text-left mtop-20">Thank you for all of the brilliant years and support.</p>
            </div>
            <div class="intro-img">
              <img class="app-store" :srcset="require('./images/sunset-visual@2x.png')+ ' 2x'" src="./images/sunset-visual.png" alt="">
            </div>
         </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import bodymovin from 'bodymovin/build/player/bodymovin_light.min.js'
import imgText from '@/components/img-text/img-text'
import appOfTheDay from '@/components/app-of-the-day/app-of-the-day'
import is from 'is_js'
import services from '../../services/services.js'

export default {
  name: 'home',
  components: {
    'img-text': imgText,
    'app-of-the-day': appOfTheDay
  },
  data () {
    return {
      is: is,
      animaton: {},
      animationFailed: false,
      animationLoaded: false,
      fallback: false,
      images: 0,
      learnMore: {
        private: false,
        openInternet: false
      },
      platforms: ['mac', 'windows', 'ios', 'android'],
      productDemo: 'mac',
      stepsIn: false,
      screenshots: [],
      lazyLoad: false
    }
  },
  created: function () {
    this.productDemo = is.mac() ? 'mac' : 'windows'
  },
  computed: {
    isApple: function () {
      return is.mac() || is.ios()
    },
    deviceName: function () {
      let device = 'Mac'
      if (is.windows()) {
        device = 'PC'
      } else if (is.ios()) {
        device = 'iPhone'
      } else if (is.ipad()) {
        device = 'iPad'
      } else if (is.android()) {
        device = 'Android'
      }
      return device
    }
  },
  beforeMount: function () {
    this.$emit('modifyLayout', {
      bgColor: 'bg-blue'
    })
    this.loadAnimationImgs()
  },
  mounted () {
    this.$nextTick(function () {
      this.lazyLoad = true
      this.loadScreenshotImgs()
    })
  },
  methods: {
    loadScreenshotImgs: function () {
      let size = ''
      if (window.devicePixelRatio > 1) {
        size = '@2x'
      }
      let imgs = ([require('./images/screenshots-mac' + size + '.png'),
        require('./images/screenshots-ios' + size + '.png'),
        require('./images/screenshots-windows' + size + '.png'),
        require('./images/screenshots-android' + size + '.png')
      ])
      services.preloadImages(imgs).then((loadedImgs) => {
        this.screenshots = loadedImgs
      })
    }
  },
  beforeDestroy: function () {
    this.animation.removeEventListener('complete')
    this.animation.removeEventListener('data_failed')
  }
}
</script>

<style scoped lang="stylus" src="./home.styl" >


// WEBPACK FOOTER //
// src/views/home/home.vue